import { ref } from '@nuxtjs/composition-api'
import { currency, toPercent } from '../modules/client/utilities'

export default function usePrice() {
  function formatPrice(newVal, oldVal) {
    if (newVal && !/^(\d+)(\.(\d*))?$/g.test(newVal)) {
      return oldVal
    }
    return newVal
  }

  const watchPriceTimeoutId = ref(null)
  function watchPriceFormatting(source, newVal, oldVal) {
    if (!watchPriceTimeoutId.value) {
      watchPriceTimeoutId.value = setTimeout(() => {
        source.value = formatPrice(newVal, oldVal)
        setTimeout(() => {
          watchPriceTimeoutId.value = null
        }, 0)
      }, 0)
    }
  }

  return {
    currency,
    toPercent,
    formatPrice,
    watchPriceFormatting
  }
}
